import WidgetDesignerRightPanel from './WidgetDesignerRightPanel';

export default WidgetDesignerRightPanel;
